export { default as SocialHistory } from './SocialHistory';
